<template>
    <div class="t-textarea" @keypress.ctrl="unsetEdit" v-click-outside="unsetEdit" :class="{mobile:$vuetify.breakpoint.xs}"> 
        <v-textarea
            v-if="!initial"
            v-model="content"
            :rows="rows"
            solo
            @input="handleInput"
            @keypress.ctrl="ctrlEnter"
            :autofocus="autofocus"
            :outlined="$vuetify.breakpoint.xsOnly"
            placeholder="Please, input text"
        />
        <div v-else class="relative">
            <template v-if="noEditor">
                <div class="formatted" :class="{formatContent:contentNotice}" v-if="!edit" @dblclick="setEdit" v-html="formattedText"/>
                <v-textarea
                    v-else
                    v-model="content"
                    :rows="rows"
                    solo
                    @input="handleInput"            
                />      
            </template>
            <template v-else>
                <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
                    <div>
                        <div class="pointer" @click="menu = true" v-show="!menu">...</div>
                        <div class="menubar" v-show="menu">                    
                            <span class="menu_button" :class="{ 'is-active': isActive.bold() }" @click="commands.bold"><b>b</b></span>
                            <span class="menu_button" :class="{ 'is-active': isActive.italic() }" @click="commands.italic"><i>i</i></span>
                            <span class="menu_button" :class="{ 'is-active': isActive.strike() }" @click="commands.strike">strike</span>
                            <span class="menu_button underline" :class="{ 'is-active': isActive.underline() }" @click="commands.underline">u</span>
                            <span class="menu_button" :class="{ 'is-active': isActive.code() }" @click="commands.code">code</span>
                            <span class="menu_button" :class="{ 'is-active': isActive.heading({ level: 3 }) }" @click="commands.heading({ level: 3 })">h3</span>
                            <span class="menu_button" :class="{ 'is-active': isActive.bullet_list() }" @click="commands.bullet_list">ul</span>
                            <span class="menu_button" :class="{ 'is-active': isActive.ordered_list() }" @click="commands.ordered_list">ol</span>
                            <span class="menu_button" :class="{ 'is-active': isActive.blockquote() }" @click="commands.blockquote">q</span>
                            <span class="menu_button" :class="{ 'is-active': isActive.code_block() }" @click="commands.code_block">code</span>
                            <v-menu offset-y>
                                <template v-slot:activator="{ on }">
                                    <span class="menu_button" v-on="on">Colors</span>
                                </template>
                                <v-color-picker class="ma-2" :swatches="swatches" show-swatches @input="val => editor.commands.textcolor({color: val.hex})"></v-color-picker>
                            </v-menu>
                            <span class="menu_button" @click="commands.horizontal_rule">hr</span>
                            <span class="menu_button" @click="commands.undo">↶</span>
                            <span class="menu_button" @click="commands.redo">↷</span>
                    </div>
                    </div>
                </editor-menu-bar>            
                <editor-content @paste.native="onPaste($event)" :editor="editor" ref="container" class="t-editor" :class="{'no-content': !value && showPlaceholder}" @click.native="showPlaceholder = false"/>
            </template>
        </div>        
    </div>    
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import ClickOutside from 'vue-click-outside'
    import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
    // import Placeholder from '@tiptap/extension-placeholder'
    import {
        Blockquote,
        CodeBlock,
        HardBreak,
        Heading,
        HorizontalRule,
        OrderedList,
        BulletList,
        ListItem,
        TodoItem,
        TodoList,
        Bold,
        Code,
        Italic,
        Link,
        Strike,
        Underline,
        History,
    } from 'tiptap-extensions'    
    import TextColor from './TextColor'
    import { formatText } from '../../helpers';

    export default {
        name: 'TTextArea',
        props: ['value', 'rows', 'autofocus', 'noEditor', 'contentNotice'],
        components:{
            EditorContent,
            EditorMenuBar,
        },
        data () {
            return {
                showPlaceholder: true,
                images: [],
                menu: false,
                initial: true,
                content: this.value,
                edit: false,
                formattedText: formatText('' + this.value),
                swatches: [
                    ['#FF0000', '#AA0000', '#550000'],
                    ['#FFFF00', '#AAAA00', '#555500'],
                    ['#00FF00', '#00AA00', '#005500'],
                    ['#00FFFF', '#00AAAA', '#005555'],
                    ['#0000FF', '#0000AA', '#000055'],
                ],                
                editor: new Editor({
                    extensions: [
                        new Blockquote(),
                        new BulletList(),
                        new CodeBlock(),
                        new HardBreak(),
                        new Heading({ levels: [3] }),
                        new HorizontalRule(),
                        new ListItem(),
                        new OrderedList(),
                        new TodoItem(),
                        new TodoList(),
                        new Link(),
                        new Bold(),
                        new Code(),
                        new Italic(),
                        new Strike(),
                        new Underline(),
                        new History(),
                        new TextColor(),
                        // new Placeholder.configure({
                        //     // Use a placeholder:
                        //     placeholder: 'Write something …',
                        //     // Use different placeholders depending on the node type:
                        //     // placeholder: ({ node }) => {
                        //     //   if (node.type.name === 'heading') {
                        //     //     return 'What’s the title?'
                        //     //   }

                        //     //   return 'Can you add some further context?'
                        //     // },
                        // }),
                    ],
                    content: formatText('' + this.value),
                    onUpdate: ({ getHTML }) => {
                        this.$emit('input', getHTML())
                    },
                }),
            }
        },
        computed:{
            ...mapGetters(["current" , "current_task"]),
        },
        methods: {
            ...mapActions(['addAttachmentsInTask']),
            handleInput (e) {
                this.$emit('input', this.content)
            },
            changeColor(val){
                this.editor.commands.textcolor({color: 'red'}) 
                console.log(this.editor.commands.textcolor({color: val.hex})   );
                 
            },
            setEdit(){
                this.edit = true
            },
            unsetEdit(){
                this.edit = false
                this.formattedText = formatText(this.value)
            },
            ctrlEnter() {
                this.$emit('ctrlEnter')
            },
            onPaste(event) {
                const images = this.images
                const items = event.clipboardData.items;
                for (const item of items) {
                    if (item.kind == 'file') {
                        const blob = item.getAsFile()
                        this.$emit('pasteFile', blob)
                        // const reader = new FileReader()
                        // reader.onload = (evt) => images.push(evt.target.result)
                        // this.addAttachmentsInTask({_id: this.current._id, task_id: this.current_task._id, urls: images})
                        // reader.readAsDataURL(blob)
                    }
                }
            }
        },
        directives: {
            ClickOutside
        },  
        mounted() {
            // console.log('<p>' + this.formattedText + '</p>');
            // setTimeout(() => {
            //     if (this.$refs.container) {                                        
            //         const editor = this.$refs.container.$el.querySelector(".ProseMirror")
            //         const allTagsA = editor.querySelectorAll("a")
            //         const regexp = /(\(.*?)?\b((?:https?|ftp|file):\/\/[-a-z0-9+&@#\/%?=~_()|!:,.;]*[-a-z0-9+&@#\/%=~_()|])/ig;
            //         // console.log(allTagsA);
            //         for (const tag of allTagsA) {
            //             if (tag.getAttribute('href').indexOf('<a ') >= 0) {        
            //                 debugger                
            //                 const newA = document.createElement('a')
            //                 newA.setAttribute('href', tag.getAttribute('href').match(regexp)[0])
            //                 newA.innerText = tag.innerText
            //                 tag.parentNode.replaceChild(newA, tag)
            //                 console.log(newA)
            //             }
            //         }
            //     }
            // },0)
        },
        beforeDestroy() {
            this.editor.destroy()
        },        
    }
</script>

<style lang="scss" scoped>
    .formatted{
        padding: 38px 0px 4px 36px;
        overflow-wrap: break-word;
        // height: 285px;
        overflow: hidden;
        // background: linear-gradient(#333,#eee);
        // background-clip: text;
        // -webkit-text-fill-color: transparent;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 23px;
        color: #383838;
        &.formatContent {
            padding-left: 36px;
            height: auto;
            -webkit-text-fill-color: #383838;
        }
    }
    .menu_button{
        border: 1px solid transparent;
        cursor: pointer;
        &:hover{
            border: 1px solid gray;
        }
        padding: 0 3px
    }
    .menubar {
        font-size: 14px;
    }
</style>

<style lang="scss">
    .t-textarea{
        min-height: 150px;
        .t-editor.no-content::before {
            content: "Введите текст";
            color: #898989;
            font-size: 14px;
            cursor: text;
            position: absolute;
            margin-top: 6px;
            margin-left: 20px;
        }
        .v-textarea{
            &.primary--text{
                color: #b9f3a6 !important;
            }
        }
        .v-text-field__details{
            display: none !important;
        } 
        .v-input__control{
            background: #fff;
        }
        .v-input__slot{
            margin: 0;
        }        
        &.mobile{
            padding: 0;
            .v-input__slot{
                margin: 0;
            }
        } 
        p{
            margin-bottom: 12px !important;
        }        
        .ProseMirror {
            padding: 4px 8px 4px 8px;
            min-height: 150px;
            outline: none;
        }
    }
    .task-view{
        .t-textarea{
            margin: 10px;
            border-radius: 6px;
            padding: 8px;
        }
    }
</style>